"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSubAlign = void 0;
const interval_1 = require("../utils/interval");
function calculateSubAlign(alignment, displayStart1, displayEnd1, displayStart2, displayEnd2) {
    const { start1, end1, start2, end2 } = alignment;
    const noIntervalInfo1 = displayStart1 === 0 && displayEnd1 === 0;
    const noIntervalInfo2 = displayStart2 === 0 && displayEnd2 === 0;
    if (noIntervalInfo1 && noIntervalInfo2)
        return alignment;
    const displayStart1Position = calculatePosition(start1, end1, displayStart1);
    const displayEnd1Position = calculatePosition(start1, end1, displayEnd1);
    const displayStart2Position = calculatePosition(start2, end2, displayStart2);
    const displayEnd2Position = calculatePosition(start2, end2, displayEnd2);
    if (displayStart1Position === displayEnd1Position && !noIntervalInfo1)
        return null;
    if (displayStart2Position === displayEnd2Position && !noIntervalInfo2)
        return null;
    const displayPosions = displayStart1 === 0 && displayEnd1 === 0
        ? [displayStart2Position, displayEnd2Position]
        : displayStart2 === 0 && displayEnd2 === 0
            ? [displayStart1Position, displayEnd1Position]
            : (0, interval_1.intersection)([displayStart1Position, displayEnd1Position], [displayStart2Position, displayEnd2Position]);
    if (displayPosions.length === 0)
        return null;
    const [displayStartPosition, displayEndPosition] = displayPosions;
    displayStart1 = position2Site(start1, end1, displayStartPosition);
    displayEnd1 = position2Site(start1, end1, displayEndPosition);
    displayStart2 = position2Site(start2, end2, displayStartPosition);
    displayEnd2 = position2Site(start2, end2, displayEndPosition);
    return Object.assign(Object.assign({}, alignment), { start1: displayStart1, end1: displayEnd1, start2: displayStart2, end2: displayEnd2 });
}
exports.calculateSubAlign = calculateSubAlign;
function calculatePosition(start, end, point) {
    if (point < Math.min(start, end))
        return start < end ? 0 : 1;
    if (point > Math.max(start, end))
        return start < end ? 1 : 0;
    return (Math.abs(point - start) + 1) / (Math.abs(end - start) + 1);
}
function position2Site(start, end, position) {
    if (position === 0)
        return start;
    if (position === 1)
        return end;
    let distance = Math.abs(end - start) + 1;
    const site = start > end
        ? start - (distance * position - 1)
        : start + (distance * position - 1);
    return Number(site.toFixed(0));
}
